const PORTAL_API = `https://central-de-suporte-tecnico-d71b7ec7.base44.app/api/apps/692ce8b41b53f8d1d71b7ec7/functions`;

const invokePublic = async (funcName, params) => {
  const res = await fetch(`${PORTAL_API}/${funcName}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params)
  });
  if (!res.ok) throw new Error(`Erro ${res.status}`);
  return res.json();
};

export const portalLogin = (params) => invokePublic('portalLogin', params);
export const portalCadastro = (params) => invokePublic('portalCadastro', params);
export const criarSolicitacaoCompra = (params) => invokePublic('criarSolicitacaoCompra', params);
export const listarSolicitacoesPortal = (params) => invokePublic('listarSolicitacoesPortal', params);
export const listarSubtarefas = (params) => invokePublic('listarSubtarefas', params);
export const mensagensPortal = (params) => invokePublic('mensagensPortal', params);
export const registrarAnexoSolicitacao = (params) => invokePublic('registrarAnexoSolicitacao', params);
